import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../../hooks/useConfiguration";
import useSessionStorage from "../../../hooks/useSessionStorage";
import Modal from "../../common/Modal/modal";
import ModifyCheckTime from "../../common/ModifyCheckTime/ModifyCheckTime";
import Ratings from "../../common/StarRating/ratings";
import * as Toasts from "../../common/Toastify";
import {
  getJobDetails,
  modifyCheckinCheckoutTime,
  modifyShiftEndTime,
  saveApproveJob,
} from "./action";
import { jobDetailsSelector } from "./selector";
import { setModifyTimeInfo } from "./slice";
import moment from "moment";
import ToolTip from "../../common/ToolTip/ToolTip";
import ReactStars from "react-rating-stars-component";
import SingleShiftClaimInfo from "./claimedInfo/singleShiftClaimInfo";
import EncounterClaimInfo from "./claimedInfo/encounterClaimInfo";
import MultishiftClaimInfo from "./claimedInfo/multishiftClaimInfo";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  // hooks
  const storage = useSessionStorage();
  const dispatch = useDispatch();
  const config = useConfiguration();
  const navigate = useNavigate();

  // get from the details via props
  const {
    claimedCandidateInfo,
    jobId,
    jobClaimId,
    jobDate,
    jobShiftUniqueId,
    candidateBillingsInfo,
    jobDetails,
    PageName,
  } = props;

  // get the details from Job Details Selector
  const {
    modifyTimeInfo: { checkintime, checkouttime, shiftstarttime, shiftendtime },
    backPath,
  } = useSelector(jobDetailsSelector);

  // Send Mail for mail popup input Error Validation
  const [errorText, setErrorText] = useState();

  // get the details from Local Storage
  const login = storage.getItem("login");

  // data Initialized
  const [showModal, setShowModal] = useState(false);
  const [notes, setNotes] = useState("");
  const [rating, setRating] = useState(0);
  const [isApproved, setisApproved] = useState(false);
  const [jobsClaimId, setjobsClaimId] = useState(0);
  const [modifyTime, setModifyTime] = useState({
    checkintime: "",
    checkouttime: "",
    shiftstarttime: "",
    shiftendtime: "",
  });
  const claimedInfoRef = useRef(claimedCandidateInfo)
  const showMap = (event, item) => {
    event.preventDefault();
    setShowModal(!showModal);
    if (item) {
      setNotes(item?.notes);
      setRating(item?.rating);
      setisApproved(item?.isApproved);
      setjobsClaimId(item?.jobsClaimId);
    }
  };
  const closeMap = (event) => {
    event.preventDefault();
    setShowModal(!showModal);
    setNotes("");
    setRating(0);
    setisApproved(false);
    setjobsClaimId(0);
  };
  const getStarValue = (starValue) => {
    setRating(starValue);
  };

  const saveRating = () => {
    const params = {
      jobUniqueId: jobId,
      appUserUniqueId: login.appUserUniqueId,
      ratingNumber: rating.toString(),
      notes: notes,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      jobsShiftUniqueId: jobShiftUniqueId,
    };

    if (notes?.length < 500) {
      if (notes && rating) {
        dispatch(
          saveApproveJob({
            url: `${config.baseUrl}/Employers/approvejob`,
            params,
          })
        ).then(() => {
          dispatch(getJobDetails(config.baseUrl, jobId, jobDate, jobClaimId));
        });

        setShowModal(!showModal);
        setNotes("");
        setRating(0);
        setisApproved(false);
        setjobsClaimId(0);
      } else {
        Toasts.info("Please Give Ratings And Comments");
      }
    } else {
      setErrorText("Please give less then 500 characters");
    }
  };

  useEffect(() => {
    if (
      claimedCandidateInfo?.checkedInDate &&
      claimedCandidateInfo?.checkedOutDate
    ) {
      setModifyTime((prev) => ({
        ...prev,
        checkintime: claimedCandidateInfo?.checkedInDate,
        checkouttime: claimedCandidateInfo?.checkedOutDate,
      }));
      dispatch(
        setModifyTimeInfo({
          name: "checkintime",
          value: moment(claimedCandidateInfo?.checkedInDate).format("hh:mm A"),
        })
      );
      dispatch(
        setModifyTimeInfo({
          name: "checkouttime",
          value: moment(claimedCandidateInfo?.checkedOutDate).format("hh:mm A"),
        })
      );
    }
    if (claimedCandidateInfo?.jobDate && claimedCandidateInfo?.jobEndDate) {
      setModifyTime((prev) => ({
        ...prev,
        shiftstarttime: claimedCandidateInfo?.jobDate,
        shiftendtime: claimedCandidateInfo?.jobEndDate,
      }));
      dispatch(
        setModifyTimeInfo({
          name: "shiftstarttime",
          value: moment(claimedCandidateInfo?.jobDate).format("hh:mm A"),
        })
      );
      dispatch(
        setModifyTimeInfo({
          name: "shiftendtime",
          value: moment(claimedCandidateInfo?.jobEndDate).format("hh:mm A"),
        })
      );
    }
  }, [
    claimedCandidateInfo?.checkedInDate,
    claimedCandidateInfo?.checkedOutDate,
    claimedCandidateInfo?.jobDate,
    claimedCandidateInfo?.jobEndDate,
  ]);
  const modifyTimeChangeHandler = (target) => {
    const { value, name } = target;
    if (name === "shiftstarttime" || name === "shiftendtime") {
      const beginningTime =
        name === "shiftstarttime"
          ? value
          : modifyTime?.shiftstarttime
      const endTime =
        name === "shiftstarttime"
          ? modifyTime?.shiftendtime
          : value
          // console.log({beginningTime,endTime,result: beginningTime > endTime, START:new Date(beginningTime), END:new Date(endTime),ENDrESYLT:new Date(beginningTime) > new Date(endTime)});
        if(new Date(beginningTime) > new Date(endTime)) {
          Toasts.error(
            "Shift start time should not be greater than Shift end time"
          );
          return
        }
    }
    if (name === "checkintime" || name === "checkouttime") {
      const beginningTime =
        name === "checkintime" ? value: modifyTime?.checkintime;
      const endTime =
        name === "checkintime" ? modifyTime?.checkouttime : value;
        // console.log({checInTime:new Date(beginningTime),checkoutTIme:new Date(endTime),value,modifyTime,beginningTime,endTime});
      if (new Date(beginningTime) > new Date(endTime)) {
        Toasts.error("Check in time should not be greater than Check out time");
        return;
      }
    }
    setModifyTime((prev) => ({ ...prev, [name]:moment(value).format("YYYY-MM-DDTHH:mm:ss")  }));
    dispatch(
      setModifyTimeInfo({ name, value: moment(value).format("hh:mm A") })
    );
  };
  const submitModifyTimeHandler = () => {
    // const beginningTime = moment(checkintime, "h:mma");
    // const endTime = moment(checkouttime, "h:mma");
    // if (endTime.isBefore(beginningTime)) {
    //   Toasts.error("Check in time should not be greater than Check out time");
    //   return;
    // }
    dispatch(
      modifyCheckinCheckoutTime({
        url: config.baseUrl,
        params: {
          jobsClaimId: jobClaimId,
          occurenceDate: jobDate,
          startDateTime: modifyTime?.checkintime,
          endDateTime: modifyTime?.checkouttime,
          jobsShiftUniqueId: jobShiftUniqueId,
        },
      })
    ).then((response) => {
      if (response) {
        dispatch(getJobDetails(config.baseUrl, jobId, jobDate, jobClaimId));
      }
    });
  };

  const modiftShiftTimeHandler = () => {
    // const beginningTime = moment(shiftstarttime, "h:mma");
    // const endTime = moment(shiftendtime, "h:mma");
    // if (endTime.isBefore(beginningTime)) {
    //   Toasts.error(
    //     "Shift start time should not be greater than Shift end time"
    //   );
    //   return;
    // }
    dispatch(
      modifyShiftEndTime({
        url: config.baseUrl,
        params: {
          jobsClaimId: jobClaimId,
          occurenceDate: jobDate,
          startDateTime: modifyTime?.shiftstarttime,
          endDateTime: modifyTime?.shiftendtime,
          jobsShiftUniqueId: jobShiftUniqueId,
        },
      })
    ).then((response) => {
      if (response) {
        dispatch(getJobDetails(config.baseUrl, jobId, jobDate, jobClaimId));
      }
    });
  };

  const shiftHoursCalc = (time) => {
    let shiftHours = "";
    const hours = Math.floor(parseInt(time) / 60);
    const minutes = parseInt(time) % 60;
    if (hours) {
      shiftHours += `${hours} ${parseInt(hours) === 1 ? "hr " : "hrs "}`;
    }
    if (minutes) {
      shiftHours += `${minutes} mins`;
    }
    return shiftHours;
  };

  const VariablePayRateTable = (
    <table className="table table-responsive">
      <thead>
        <tr>
          <th className="text-capitalize">Start Time</th>
          <th className="text-capitalize">End Time</th>
          <th className="text-capitalize">Candidate Rate</th>
          <th className="text-capitalize">Billing Rate</th>
        </tr>
      </thead>
      <tbody>
        {claimedCandidateInfo?.payRates?.map((item, index) => {
          return (
            <tr className="border-bottom mt-2 bg-white">
              <td>{moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}</td>
              <td>{moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}</td>
              <td>{item?.hourlyPayRate}</td>
              <td>{item?.totalRate}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <div className="col-md-12 col-xl-12">
      <div className="card">
        {showModal && (
          <Modal
            showHide={closeMap}
            saveFunction={saveRating}
            label={"Review"}
            center={true}
            size={"lg"}
          >
            <div className="row">
              <div className="form-group">
                <div className="col-lg-6 col-md-5">
                  <label htmlFor="Ratings">Shift Rating:</label>
                  <Ratings
                    getStarValue={getStarValue}
                    initialValue={parseFloat(rating)}
                    showTooltip={true}
                  />
                </div>
                <div className="">
                  <label htmlFor="exampleFormControlTextarea1">
                    Reviewer comments:
                  </label>

                  <textarea
                    style={{ height: "100px" }}
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                  ></textarea>
                  <span className="text-danger">
                    {errorText ? errorText : ""}
                  </span>
                </div>
                <div className="col-lg-2 col-md-4">
                  <label
                    className="form-check-label"
                    style={{ float: "left" }}
                    htmlFor="flexSwitchCheckDefault"
                  >
                    Approve
                  </label>
                  <div
                    className="form-check form-switch custom-switch-lg"
                    style={{ marginLeft: "15px" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isApproved}
                      onChange={(e) => setisApproved(e.target.checked)}
                      role="switch"
                      id="flexSwitchCheckDefault"
                      style={{ height: "20px", width: "37px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        )}
       <div>
            {props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 1 || props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 4 ? (
              <SingleShiftClaimInfo {...props.jobDetails} />
            ) : props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 2 ? (
              <EncounterClaimInfo {...props.jobDetails} />
            ) : props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 3 ? (
              <MultishiftClaimInfo
                {...props.jobDetails}
                currentShiftDate={props?.currentShiftDate}
              />
            ) : (
              ""
            )}
          <div className="card-body" style={{border:"none",marginTop:"-2rem"}}>
                 {/* Fourth Row */}
                 <div className="row">
              <div className="d-flex ">
                <div className="col">
                  {props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 2 ? (
                    ""
                  ) : (
                    <div className="row">
                      {claimedCandidateInfo?.checkedInDate &&
                      claimedCandidateInfo?.checkedOutDate ? (
                        <>
                          <div className={"col-lg-4 col-md-4"}>
                            <ModifyCheckTime
                            defaultRefDate = {claimedInfoRef.current?.jobDate}
                              updateValue={modifyTimeChangeHandler}
                              modifyTime={modifyTime?.shiftstarttime}
                              label={"Shift Start Time:"}
                              name={"shiftstarttime"}
                              isDisabled={
                                PageName === "completedShifts" ||
                                PageName === "awaitingpayments"
                                  ? true
                                  : PageName === "awaitingShifts"
                                  ? claimedCandidateInfo?.approversList?.some(
                                      (item) => {
                                        if (
                                          item.approverUserUniqueId ===
                                          login.appUserUniqueId
                                        ) {
                                          return item.isApproved === true;
                                        }
                                      }
                                    )
                                  : !claimedCandidateInfo?.approversList?.some(
                                      (item) =>
                                        item.approverUserUniqueId ===
                                        login.appUserUniqueId
                                    )
                              }
                            />
                          </div>
                          <div className={"col-lg-4 col-md-4"}>
                            <ModifyCheckTime
                            defaultRefDate = {claimedInfoRef.current?.jobEndDate}
                              updateValue={modifyTimeChangeHandler}
                              modifyTime={modifyTime?.shiftendtime}
                              label={"Shift End Time:"}
                              name={"shiftendtime"}
                              isDisabled={
                                PageName === "completedShifts" ||
                                PageName === "awaitingpayments"
                                  ? true
                                  : PageName === "awaitingShifts"
                                  ? claimedCandidateInfo?.approversList?.some(
                                      (item) => {
                                        if (
                                          item.approverUserUniqueId ===
                                          login.appUserUniqueId
                                        ) {
                                          return item.isApproved === true;
                                        }
                                      }
                                    )
                                  : !claimedCandidateInfo?.approversList?.some(
                                      (item) =>
                                        item.approverUserUniqueId ===
                                        login.appUserUniqueId
                                    )
                              }
                            />
                          </div>

                          {PageName === "completedShifts" ||
                          PageName === "awaitingpayments" ? (
                            ""
                          ) : (
                            <div
                              className="col-lg-4 col-md-4 mt-4"
                              style={{ cursor: "pointer" }}
                            >
                              <button
                                type="submit"
                                disabled={
                                  PageName === "awaitingShifts"
                                    ? claimedCandidateInfo?.approversList?.some(
                                        (item) => {
                                          if (
                                            item.approverUserUniqueId ===
                                            login.appUserUniqueId
                                          ) {
                                            return item.isApproved === true;
                                          }
                                        }
                                      )
                                    : !claimedCandidateInfo?.approversList?.some(
                                        (item) =>
                                          item.approverUserUniqueId ===
                                          login.appUserUniqueId
                                      )
                                }
                                className="btn btn-primary mt-4"
                                onClick={modiftShiftTimeHandler}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* Fifth Row */}
            <div className="row">
              <div className="d-flex ">
                <div className="col">
                  {props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 2 ? (
                    ""
                  ) : (
                    <div className="row">
                      {claimedCandidateInfo?.checkedInDate &&
                      claimedCandidateInfo?.checkedOutDate ? (
                        <>
                          <div className={"col-lg-4 col-md-4"}>
                            <ModifyCheckTime
                              defaultRefDate = {claimedInfoRef.current?.checkedInDate}
                              updateValue={modifyTimeChangeHandler}
                              modifyTime={modifyTime?.checkintime}
                              label={"CheckIn Time:"}
                              name={"checkintime"}
                              isDisabled={
                                PageName === "completedShifts" ||
                                PageName === "awaitingpayments"
                                  ? true
                                  : PageName === "awaitingShifts"
                                  ? claimedCandidateInfo?.approversList?.some(
                                      (item) => {
                                        if (
                                          item.approverUserUniqueId ===
                                          login.appUserUniqueId
                                        ) {
                                          return item.isApproved === true;
                                        }
                                      }
                                    )
                                  : !claimedCandidateInfo?.approversList?.some(
                                      (item) =>
                                        item.approverUserUniqueId ===
                                        login.appUserUniqueId
                                    )
                              }
                            />
                          </div>
                          <div className={"col-lg-4 col-md-4"}>
                            <ModifyCheckTime
                            defaultRefDate = {claimedInfoRef.current?.checkedOutDate}
                              updateValue={modifyTimeChangeHandler}
                              modifyTime={modifyTime?.checkouttime}
                              label={"Checkout Time:"}
                              name={"checkouttime"}
                              isDisabled={
                                PageName === "completedShifts" ||
                                PageName === "awaitingpayments"
                                  ? true
                                  : PageName === "awaitingShifts"
                                  ? claimedCandidateInfo?.approversList?.some(
                                      (item) => {
                                        if (
                                          item.approverUserUniqueId ===
                                          login.appUserUniqueId
                                        ) {
                                          return item.isApproved === true;
                                        }
                                      }
                                    )
                                  : !claimedCandidateInfo?.approversList?.some(
                                      (item) =>
                                        item.approverUserUniqueId ===
                                        login.appUserUniqueId
                                    )
                              }
                            />
                          </div>

                          {PageName === "completedShifts" ||
                          PageName === "awaitingpayments" ? (
                            ""
                          ) : (
                            <div
                              className="col-lg-4 col-md-4 mt-4"
                              style={{ cursor: "pointer" }}
                            >
                              <button
                                type="submit"
                                disabled={
                                  PageName === "awaitingShifts"
                                    ? claimedCandidateInfo?.approversList?.some(
                                        (item) => {
                                          if (
                                            item.approverUserUniqueId ===
                                            login.appUserUniqueId
                                          ) {
                                            return item.isApproved === true;
                                          }
                                        }
                                      )
                                    : !claimedCandidateInfo?.approversList?.some(
                                        (item) =>
                                          item.approverUserUniqueId ===
                                          login.appUserUniqueId
                                      )
                                }
                                className="btn btn-primary mt-4"
                                onClick={submitModifyTimeHandler}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* FifthX */}

            {/* Sixth row */}
            <div className="row ">
              <div className="d-flex ">
                <div className="col">
                  <label className="form-label">Approvals:</label>
                  {claimedCandidateInfo?.approversList?.map((item) => (
                    <>
                      <div className="form-group">
                        <div className="row">
                          <div className="col-2">
                            <label className="form-label">Approver:</label>
                            <label>{item?.approverName}</label>
                          </div>
                          <div className="col-2">
                            <label className="form-label">Approved Date:</label>
                            <label>{item?.approvedDateToDisplay}</label>
                          </div>
                          <div className="col-2">
                            <label className="form-label">Approved:</label>
                            <label>{item?.isApproved ? "Yes" : "No"}</label>
                          </div>
                          <div className="col-2">
                            <label className="form-label">Ratings:</label>
                            <div>
                              <Ratings
                                initialValue={item?.rating}
                                ratingValue={item?.rating}
                                readonly={true}
                                size={18}
                              />
                            </div>
                          </div>
                          <div className="col-2">
                            <label className="form-label">Comments:</label>
                            <label style={{ width: "100px" }}>
                              {item?.notes}
                            </label>
                          </div>
                          <div className="col-2  d-flex ">
                            {claimedCandidateInfo?.isCheckedOut === true && (
                              <>
                                {PageName === "completedShifts" ||
                                PageName === "awaitingpayments" ? (
                                  ""
                                ) : (
                                  <div>
                                    {props?.jobDetails?.jobSummeryJobsShifts
                                      ?.shiftType === 2 ? (
                                      <>
                                        {props?.jobDetails.allShiftCompleted ? (
                                          <button
                                            className="btn btn-primary "
                                            onClick={(e) => showMap(e, item)}
                                            disabled={
                                              item?.approverUserUniqueId !==
                                              login.appUserUniqueId
                                            }
                                          >
                                            Approve
                                          </button>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    ) : props?.jobDetails?.jobSummeryJobsShifts
                                        ?.shiftType === 3 ? (
                                      <button
                                        className="btn btn-primary "
                                        onClick={(e) => showMap(e, item)}
                                        disabled={true}
                                      >
                                        Approve
                                      </button>
                                    ) : (
                                      <button
                                        className="btn btn-primary "
                                        onClick={(e) => showMap(e, item)}
                                        disabled={
                                          item?.approverUserUniqueId !==
                                          login.appUserUniqueId
                                        }
                                      >
                                        Approve
                                      </button>
                                    )}
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                          <div className="col-2"></div>
                          <div className="col-2"></div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>

            {/* Seventh row */}
            <div className="row ">
              <div className="col-8">
                {claimedCandidateInfo?.isCheckedOut === true ? (
                  candidateBillingsInfo?.breakInfos?.length > 0 ? (
                    <div>
                      <label className="fw-bold">Break Info:</label>
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th className="text-capitalize">Start Time</th>
                              <th className="text-capitalize">End Time</th>
                              <th className="text-capitalize">
                                Break Duration
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {candidateBillingsInfo?.breakInfos?.map((item) => (
                              <tr>
                                <ToolTip
                                  position={"top"}
                                  value={item?.startTimeToolTipToDisplay}
                                >
                                  <td
                                    style={{ cursor: "pointer" }}
                                    className="bg-white"
                                  >
                                    {item.startTimeToDisplay}
                                  </td>
                                </ToolTip>
                                <ToolTip
                                  position={"top"}
                                  value={item?.endTimeToolTipToDisplay}
                                >
                                  <td
                                    style={{ cursor: "pointer" }}
                                    className="bg-white"
                                  >
                                    {item.endTimeToDisplay}
                                  </td>
                                </ToolTip>
                                <td className="bg-white">
                                  {item.breakTimeToDisplay}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* Eight row */}
            {props?.jobDetails?.jobSummeryJobsShifts?.shiftType === 3 && (
              <>
                <div className="row">
                  <div className="col-8">
                    <div className="col-lg-8 col-md-8">
                      <label label className="form-label">
                        MultiShift
                      </label>
                      <label htmlFor="City">
                        {props?.jobDetails?.rrurleStr}
                      </label>
                    </div>
                  </div>
                </div>
                {!props.editMode &&
                (props?.jobDetails?.deletedOccurence?.length ||
                  props?.jobDetails?.modifiedOccurreneList?.length) ? (
                  <div className="row mt-3">
                    {props?.jobDetails?.deletedOccurence &&
                      props?.jobDetails?.deletedOccurence?.length > 0 && (
                        <div className="form-group">
                          <label className="col-6 form-label">
                            Deleted Occurrence:
                          </label>
                          <ul>
                            {props?.jobDetails?.deletedOccurence.map(
                              (item, index) => (
                                <li
                                  className="col-6 text-decoration-line-through"
                                  key={index}
                                >
                                  {item}
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      )}
                    {props?.jobDetails?.modifiedOccurreneList &&
                      props?.jobDetails?.modifiedOccurreneList?.length > 0 &&
                      props?.jobDetails?.jobSummeryJobsShifts?.shiftType ===
                        3 && (
                        <div className="form-group">
                          <label className=" col-6 form-label">
                            Modified Occurrence:
                          </label>
                          <div className="d-flex border-bottom ">
                            <div className="col-2">
                              <label className="form-label">Start Date</label>
                            </div>
                            <div className="col-2">
                              <label className="form-label">End Date</label>
                            </div>
                            <div className="col-2">
                              <label className="form-label">Start Time</label>
                            </div>
                            <div className="col-2">
                              <label className="form-label">End Time</label>
                            </div>
                            <div className="col-2">
                              <label className="form-label">
                                Location Name
                              </label>
                            </div>
                            <div className="col-2">
                              {/* <label className="form-label">End Time</label> */}
                            </div>
                          </div>
                          {props?.jobDetails?.modifiedOccurreneList.map(
                            (item, index) => (
                              <>
                                <div className="d-flex border-bottom pt-2">
                                  <div className="col-2 ">
                                    <label htmlFor="City">
                                      {item.startDateToDisplay}
                                    </label>
                                  </div>
                                  <div className="col-2 ">
                                    <label htmlFor="City">
                                      {item.endDateToDisplay}
                                    </label>
                                  </div>
                                  <div className="col-2 ">
                                    <label htmlFor="City">
                                      {item.startTime}
                                    </label>
                                  </div>
                                  <div className=" col-2">
                                    <label htmlFor="City">{item.endTime}</label>
                                  </div>
                                  <div className=" col-2">
                                    <label htmlFor="City">
                                      {item?.locationName}
                                    </label>
                                  </div>
                                  <div className=" col-2">
                                    {/* <label htmlFor="City">{item?.locationName}</label> */}
                                  </div>
                                </div>
                              </>
                            )
                          )}
                        </div>
                      )}
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
            {/* nine */}
            {/* Encounter Occurrence Details */}
            {props?.jobEncounterOccurreneList?.length > 0 ? (
              <div className="form-group">
                <label className="col-6 form-label">
                  Encounter Occurrence:
                </label>

                <table className="table table-responsive">
                  <thead>
                    <tr className="border-bottom ">
                      <th className="text-capitalize">Date</th>
                      <th className="text-capitalize">Start Time</th>
                      <th className="text-capitalize">End Time</th>
                      <th className="text-capitalize">CheckedIn Date</th>
                      <th className="text-capitalize">CheckedOut Date</th>
                      <th className="text-capitalize">Patient Name</th>
                      <th className="text-capitalize">Appointment Type</th>
                      <th className="text-capitalize">
                      Candidate Encounter Rate
                    </th>
                    <th className="text-capitalize">Employer Encounter Billing Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props?.jobEncounterOccurreneList?.map((item, index) => {
                      return (
                        <tr className="border-bottom mt-2 bg-white">
                          <td>{item.encounterStartToDisplay}</td>
                          <td>{item.encounterStartTime} </td>
                          <td>{item.encounterEndTime} </td>
                          <td>
                            <span
                              style={{
                                background: `${
                                  item.encounterLateCheckedInTime && "#ffd300"
                                }`,
                              }}
                            >
                              {" "}
                              {item.checkedInDateToDisplay}{" "}
                              {item.encounterLateCheckedInTime &&
                                `(${item.encounterLateCheckedInTime})`}
                            </span>
                          </td>
                          <td>
                            <span
                              style={{
                                background: `${
                                  item.encounterLateCheckedOutTime && "#ffd300"
                                }`,
                              }}
                            >
                              {item.checkedOutDateToDisplay}{" "}
                              {item.encounterLateCheckedOutTime &&
                                `(${item.encounterLateCheckedOutTime})`}
                            </span>
                          </td>
                          <td>{item.patientName}</td>
                          <td>{item.appointmentTypeName}</td>
                          <td>{item.candidateRatePerInstanceToDisplay ? `$ ${item.candidateRatePerInstanceToDisplay}`:item.candidateRatePerInstanceToDisplay}</td>
                          <td>{item.employerRatePerInstanceToDisplay ? `$ ${item.employerRatePerInstanceToDisplay}`:item.employerRatePerInstanceToDisplay}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
            {/* <div className="row">
            {claimedCandidateInfo?.isCheckedOut === true ? (
              candidateBillingsInfo?.breakInfos?.length > 0 ? (
                <div className="col-9">
                  <div className="form-group">
                    <label className=" col-6 form-label">Break Info:</label>
                    <div className="d-flex">
                      <div className="col-3 border-bottom">
                        <label className="form-label">Start Time</label>
                      </div>
                      <div className="col-3 border-bottom">
                        <label className="form-label">End Time</label>
                      </div>
                      <div className="col-3 border-bottom">
                        <label className="form-label">Break Duration</label>
                      </div>
                    </div>
                    {candidateBillingsInfo?.breakInfos?.map((item) => (
                      <div className="mt-2">
                        <div className="d-flex">
                          <div className="col-3 border-bottom">
                            <label htmlFor="City">
                              {item.startTimeToDisplay}
                            </label>
                          </div>
                          <div className="col-3 border-bottom">
                            <label htmlFor="City">{item.endTimeToDisplay}</label>
                          </div>
                          <div className="col-3 border-bottom">
                            <label htmlFor="City">
                              {item.breakTimeToDisplay}
                            </label>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : ("")

            ) : (
              ""
            )}
          </div> */}

            {/* <div className="col-lg-4 col-md-4">
              <label className="form-label">Checked In:</label>
              <label>{claimedCandidateInfo?.isCheckedIn ? "Yes" : "No"}</label>
            </div> */}
            {/* <div className="col-lg-4 col-md-4">
              <label className="form-label">Checked Out:</label>
              <label>{claimedCandidateInfo?.isCheckedOut ? "Yes" : "No"}</label>
            </div> */}
            {/* <div className="col-lg-4 col-md-4">
              <label className="form-label">Paid:</label>
              <label>{claimedCandidateInfo?.isPaid ? "Yes" : "No"}</label>
            </div> */}
          </div>
      </div>
    </div>
  );
};
